import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Zap, Download, ShieldCheck, CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero', '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-beige py-24 px-6" data-id="element-113">
      <div className="max-w-5xl mx-auto text-center" data-id="element-114">
        {/* Title */}
        <FadeIn data-id="element-115">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-6 leading-tight" data-id="element-116">
            DOS FORMAS REALES DE GENERAR INGRESOS CON AMAZON
          </h2>
          <p className="text-lg md:text-xl text-brand-text/70 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-117">
            Ahora puedes aprender los dos modelos más populares para vender en
            Amazon:
          </p>

          {/* Two models block */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-10" data-id="element-118">
            <div className="flex items-center gap-3 bg-white px-6 py-4 rounded-xl shadow-sm border border-brand-green/10" data-id="element-119">
              <CheckCircle2 className="w-6 h-6 text-brand-green" data-id="element-120" />
              <span className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-121">
                AMAZON FBA
              </span>
            </div>
            <div className="flex items-center gap-3 bg-white px-6 py-4 rounded-xl shadow-sm border border-brand-green/10" data-id="element-122">
              <CheckCircle2 className="w-6 h-6 text-brand-green" data-id="element-123" />
              <span className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-124">
                AMAZON FBM
              </span>
            </div>
          </div>

          <p className="text-lg md:text-xl text-brand-text/70 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-125">
            Elige el sistema que mejor se adapte a ti o aprende ambos para
            aumentar tus oportunidades de generar ingresos online desde casa.
            <br data-id="element-126" />
            <span className="text-brand-green font-semibold" data-id="element-127">
              Empieza hoy incluso si eres principiante.
            </span>
          </p>
        </FadeIn>

        {/* Image */}
        <FadeIn delay={0.2} data-id="element-128">
          <div className="mb-14" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/dhgibsR6bwtVxXTyB13P5a/ChatGPT_Image_8_may_2026,_10_49_45.png" alt="Sistema completo: Cómo vender en Amazon FBM desde cero + Bonos premium" className="w-full max-w-4xl mx-auto h-auto rounded-2xl shadow-2xl object-contain" data-id="element-130" />
          </div>
        </FadeIn>

        {/* Closing CTA */}
        <FadeIn delay={0.3} data-id="element-131">
          <div className="max-w-2xl mx-auto" data-id="element-132">
            <p className="text-xl md:text-2xl text-brand-green font-semibold mb-8 leading-relaxed" data-id="element-133">
              Empieza hoy y accede al sistema completo paso a paso.
            </p>

            <p className="text-xs font-semibold uppercase tracking-wider text-brand-text/50 mb-1" data-id="element-134">
              🔥 HOY SOLO
            </p>
            <p className="text-6xl md:text-7xl font-bold text-brand-green mb-3" data-id="element-135">
              $16.99
            </p>
            <p className="text-sm font-bold text-brand-gold uppercase tracking-wider mb-10" data-id="element-136">
              ⚡ Precio de lanzamiento — puede cambiar en cualquier momento
            </p>

            <Button onClick={goToCheckout} className="w-full sm:w-auto text-lg md:text-xl px-14 py-5" data-id="element-137">
              QUIERO APRENDER AMAZON FBM
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-5" data-id="element-138">
              <span className="flex items-center gap-1.5" data-id="element-139">
                <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-140" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-141">
                <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-142" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-143">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-144" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}